module.exports = __webpack_public_path__ + "static/media/2020-05-22 radgrad.e8ade42f.md";